import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { downloadPdf } from '../api.ts';
import { errorMessage } from '../messages.ts';
import type { Announce } from './useAnnounce.tsx';

/**
 * Scaricare il PDF del resoconto, e dirlo.
 *
 * Stessa forma di `useCsvExport`, per un file **binario**: niente celle da
 * tradurre, il server scrive già le etichette nella lingua di chi ha premuto
 * il pulsante (`report-pdf.ts`). "File pronto" si annuncia solo se il file è
 * stato davvero salvato — lo stesso principio di AJ17.
 */
function saveBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  // Vedi `saveFile` in `api.ts`: revocare subito rompe il salvataggio su
  // Firefox e Safari, che leggono il blob un istante più tardi.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export function usePdfExport(say: Announce['say']): (path: string) => Promise<void> {
  const { t } = useTranslation();

  return useCallback(
    async (path: string) => {
      try {
        const file = await downloadPdf(path);
        saveBlob(file.filename, file.blob);
        say(t('admin.export_ready', { name: file.filename }));
      } catch (error) {
        say(`${t('admin.export_failed')} ${errorMessage(t, error)}`, 'danger');
      }
    },
    [say, t],
  );
}
